// import { Icons } from '@/components/icons';
import HeadphonesURL from '@/assets/images/pricing/Headphones.svg?url';
import TapeURL from '@/assets/images/pricing/Tape.svg?url';
import RecordURL from '@/assets/images/pricing/Record.svg?url';
import SwitchURL from '@/assets/images/pricing/Switch.svg?url';

export const plans = [
  {
    icon: '/assets/images/pricing/dabbler.svg',
    title: `Dabbler`,
    price: 9.99,
    perksTitle: ``,
    perks: ['Ownable Tracks', 'Extend and trim', 'R3IMAGINE', 'Super-fast with ENJEN'],
    linkText: `Choose Plan`,
    linkHref: `#`,
    newWindow: true,
  },
  {
    icon: '/assets/images/pricing/soloist.svg',
    title: `Soloist`,
    price: 24.99,
    perksTitle: `Additional Tools for Soloist`,
    perks: [
      'Adding intros and outros with STRUCUTR3',
      'Tweak any part of your track with R3FILL',
      'Manage you work flow better with custom folders and bulk downloads',
      'Up to 5 concurrent generations',
    ],
    linkText: `Choose Plan`,
    linkHref: `#`,
    newWindow: true,
  },
  {
    icon: '/assets/images/pricing/pro.svg',
    title: `Pro`,
    price: 249.99,
    perksTitle: `Everything in Dabbler and Soloist plus;`,
    perks: ['100 concurrent generations', 'Create filters'],
    linkText: `Choose Plan`,
    linkHref: `#`,
    newWindow: true,
  },
];

export const planFeatures = {
  plans: [
    {
      title: `Free`,
      price: 'Free',
      key: 'base',
      linkText: `Try Jen Now`,
      linkHref: `http://app.jenmusic.ai/recharge`,
      newWindow: true,
      icon: HeadphonesURL,
    },
    {
      title: `Dabbler`,
      key: 'dabbler',
      price: 9.99,
      linkText: `Choose Plan`,
      linkHref: `http://app.jenmusic.ai/recharge`,
      newWindow: true,
      icon: TapeURL,
    },
    {
      title: `Soloist`,
      key: 'soloist',
      price: 24.99,
      linkText: `Choose Plan`,
      linkHref: `http://app.jenmusic.ai/recharge`,
      newWindow: true,
      icon: RecordURL,
    },
    {
      title: `Pro`,
      key: 'pro',
      price: 249.99,
      linkText: `Choose Plan`,
      linkHref: `http://app.jenmusic.ai/recharge`,
      newWindow: true,
      icon: SwitchURL,
    },
  ],
  sections: [
    {
      sectionName: 'Creation',
      features: [
        {
          title: 'Credits per Month',
          tooltip: 'Number of credits you get per month',
          Novice: '20 Credits',
          Dabbler: '300 Credits',
          Soloist: '1,000 Credits',
          Pro: '10,000 Credits',
          isChild: false,
        },
        {
          title: 'Downloadable Tracks',
          tooltip: 'Download completed tracks directly to your device.',
          Novice: 'Yes',
          Dabbler: 'Yes',
          Soloist: 'Yes',
          Pro: 'Yes',
          isChild: false,
        },
        {
          title: 'Extend Tracks',
          tooltip: 'Instantly lengthen your music tracks while maintaining seamless flow and high-quality sound.',
          Novice: 'Limit of 4',
          Dabbler: 'Yes',
          Soloist: 'Yes',
          Pro: 'Yes',
          isChild: false,
        },
        {
          title: 'Trim Tracks',
          tooltip: 'Easily shorten tracks to fit your specific project needs with precision trimming.',
          Novice: 'No',
          Dabbler: 'Yes',
          Soloist: 'Yes',
          Pro: 'Yes',
          isChild: false,
        },
        {
          title: 'R3FILL™️',
          tooltip:
            'Redesign specific parts of a track by replacing sections with new prompts. Ideal for fine-tuning and experimenting with creative ideas.',
          Novice: 'No',
          Dabbler: 'Yes',
          Soloist: 'Yes',
          Pro: 'Yes',
          isChild: false,
        },
        {
          title: 'STRUCTUR3™️',
          tooltip: 'Reshape the song structure by adding intros and outros. Gain full control over how your track unfolds.',
          Novice: 'No',
          Dabbler: 'Yes',
          Soloist: 'Yes',
          Pro: 'Yes',
          isChild: false,
        },
        {
          title: 'Intro',
          tooltip: 'Start your track with a seamless intro such as a simplified progression or gradual rise.',
          Novice: 'No',
          Dabbler: 'Yes',
          Soloist: 'Yes',
          Pro: 'Yes',
          isChild: true,
        },
        {
          title: 'Outro',
          tooltip: 'Create a smooth, cohesive ending with an outro that naturally allows the track to conclude with finesse and flow.',
          Novice: 'No',
          Dabbler: 'Yes',
          Soloist: 'Yes',
          Pro: 'Yes',
          isChild: true,
        },
        {
          title: 'Fade Out',
          tooltip: 'Gently conclude your track with a fade out, gradually lowering the volume to create a smooth finish.',
          Novice: 'No',
          Dabbler: 'Yes',
          Soloist: 'Yes',
          Pro: 'Yes',
          isChild: false,
        },
        {
          title: 'Download Stems',
          tooltip:
            'Access isolated track components for detailed editing or remixing. Perfect for professionals wanting full flexibility in their DAW.',
          Novice: 'No',
          Dabbler: 'Yes',
          Soloist: 'Yes',
          Pro: 'Yes',
          isChild: false,
        },
        {
          title: 'R3IMAGINE™️',
          tooltip:
            'Take an uploaded audio sample, such as a hum, a knock, or a short sample, and transform it into a complete track or different instrument sound, providing an entirely new interpretation.',
          Novice: 'No',
          Dabbler: 'Yes',
          Soloist: 'Yes',
          Pro: 'Yes',
          isChild: false,
        },
        {
          title: '.wav Files',
          tooltip: 'Export your tracks in high-quality .wav format.',
          Novice: 'No',
          Dabbler: 'Yes',
          Soloist: 'Yes',
          Pro: 'Yes',
          isChild: false,
        },
        {
          title: 'Concurrent Jenerations',
          tooltip: 'Jenerate multiple tracks simultaneously, allowing you to experiment, compare, and perfect your ideas faster than ever.',
          Novice: '1',
          Dabbler: '1',
          Soloist: 'Up to 5',
          Pro: 'Up to 25',
          isChild: false,
        },
        {
          title: 'Custom Folders',
          tooltip:
            'Organize your projects effortlessly with customizable folders, keeping your work neatly arranged and easily accessible in a way that fits your personalized workflow.',
          Novice: 'No',
          Dabbler: 'No',
          Soloist: 'Yes',
          Pro: 'Yes',
          isChild: false,
        },
        {
          title: 'Bulk Downloads',
          tooltip:
            'Download multiple tracks and stems at once, saving you time and ensuring your music files are always ready for the next stage of production.',
          Novice: 'No',
          Dabbler: 'No',
          Soloist: 'Yes',
          Pro: 'Yes',
          isChild: false,
        },
      ],
    },
  ],
};

export const FAQs = [
  {
    question:
      'What subscription plans are available, and how do they differ? What if I want to buy packages of credits without a subscription?',
    answer: `We offer a limited free tier and three subscription plans:
    <ul style="list-style: disc; padding-left: 2rem;">
      <li>Novice (Free): Includes 20 monthly credits, basic features, and access to a limited preview of our tools.</li>
      <li>Dabbler ($9.99/month): Offers 300 credits monthly, additional tools like trimming tracks, and downloadable audio in high quality .wav format, and more.</li>
      <li>Soloist ($24.99/month): Ideal for premium content creators, with 1,000 monthly credits, advanced features like R3IMAGINE™ and STRUCTUR3™, and access to downloadable stems.</li>
      <li>Pro ($249.99/month): For professional artists and enterprises, offering 10,000 monthly credits, bulk downloads, custom folders, and up to 25 concurrent generations.</li>
    </ul>
    If you prefer not to subscribe, Novice users can purchase an a la carte credit package.`,
    link: '',
  },
  {
    question: 'How does the annual subscription discount work?',
    answer: 'When you pay upfront for an annual subscription, you receive a 16.7% discount, which equates to two months free.',
    link: '',
  },
  {
    question: 'What happens if I upgrade or downgrade my subscription?',
    answer:
      'Upgrades take effect immediately, giving you instant access to the upgraded plan’s features and credits. You’ll be charged the price difference for the remainder of your billing cycle. Downgrades take effect at the end of your current billing period, allowing you to use your current plan’s features until the next billing cycle.',
    link: '',
  },
  {
    question: 'Can I switch from a monthly to an annual subscription?',
    answer:
      'Yes! Switching to an annual plan takes effect immediately. Any unused days from your current monthly cycle will be credited toward your annual plan, reducing the upfront cost.',
    link: '',
  },
  {
    question: 'How are credits allocated across subscription plans?',
    answer: `Each plan comes with a set number of monthly credits at the beginning of each billing cycle. Credits do not roll over. Credit top-ups are available for purchase by subscribers.
    <ul style="list-style: disc; padding-left: 2rem;">
      <li>Novice (Free): 20 credits</li>
      <li>Dabbler: 300 credits</li>
      <li>Soloist: 1,000 credits</li>
      <li>Pro: 10,000 credits</li>
    </ul>`,
    link: '',
  },
  {
    question: 'Can I purchase additional credits if I run out? ',
    answer: 'Yes, you can purchase additional credits if you run out through a la carte packages.',
    link: '',
  },
  {
    question: 'Do credits roll over to the next month if I don’t use them?',
    answer:
      'No, credits do not roll over. They reset each month, so any unused credits will be forfeited at the end of your billing cycle.',
    link: '',
  },
  {
    question: 'What is the refund policy if I cancel my subscription?',
    answer: 'We do not offer refunds for subscriptions or credit purchases.',
    link: '',
  },
  {
    question: 'What happens to my account if I cancel my subscription?',
    answer:
      'When you cancel your subscription, you’ll retain access to your current plan’s features until the end of your billing period. After that, your account will revert to the Novice (Free) plan. We will store your files for one year after cancellation, allowing you to download them before they are removed.',
    link: '',
  },
  {
    question: 'Can I pause my subscription instead of canceling it?',
    answer:
      'We don’t offer a pause option on subscriptions. If you cancel, you’ll need to re-subscribe when you’re ready to use the platform again, and your account will revert to the Novice (Free) plan in the meantime.',
    link: '',
  },
  {
    question: 'Do you offer custom subscription plans?',
    answer:
      'You bet we do! For organizations with larger needs, we offer custom enterprise plans. Please reach out via the Get in Touch button on our website or through partnerships@jenmusic.ai to discuss options that align with your business requirements.',
    link: '',
  },
  {
    question: 'What happens if I run out of credits while I’m in the middle of creating my next magnum opus?',
    answer:
      'Don’t panic! You can quickly purchase more credits to keep the creative flow going. We won’t leave you hanging mid-beat! You can purchase 100 credits for $4.99 on all plans (except Novice) and 75 credits for $9.99 on the Novice plan.',
    link: '',
  },
  {
    question: 'Can I share my credits with my friend who’s convinced they’re the next big thing?',
    answer:
      'As much as we’d love to support your friend’s rise to the top, credits are non-transferable. However, you can make tracks for them and become the next big thing in prompt production.',
    link: '',
  },
  {
    question: 'What if I sign up for a plan, but Jen ends up being more creative than me?',
    answer:
      'That’s not possible! Jen is creative because of you and your imagination. Jen is your co-producer. She’s here to make you shine.',
    link: '',
  },
  {
    question: 'Can I gift credits to a friend who needs an audio pick-me-up?',
    answer:
      'Currently, gifting credits isn’t available, but it will be in the future. We know that the gift of music is one of the most transformative gifts you can give.',
    link: '',
  },
  {
    question: 'Why can’t you offer more free credits?',
    answer:
      'While we’d love to be more generous, the process of generating AI-driven audio content relies heavily on GPUs (Graphics Processing Units), which are both complex and expensive to operate. Providing unlimited free credits would quickly become unsustainable. We work hard to find a balance that supports users while covering the high costs of our technology.',
    link: '',
  },
];
